// translations.js
const translations = {
    en: {
      feedbackForm: 'Feedback Form',
      patientName: 'Patient Name',
      doctorName: 'Doctor Name',
      doctorOrEmployeeName: 'Doctor Or Employee Name',
      rateExperience: 'Rate your Experience',
      description: 'Suggestions or Complaints',
      submit: 'Submit',
    },
    ar: {
      feedbackForm: 'نموذج التقييم',
      patientName: 'اسم المريض',
      doctorName: 'اسم الطبيب',
      doctorOrEmployeeName: 'اسم الطبيب أو الموظف',
      rateExperience: 'التقييم',
      description: 'الاقتراحات أو الشكاوى',
      submit: 'إرسال',
    },
  };
  
  export default translations;
  